<template>
    <div class="nav-scroller bg-white box-shadow">
        <nav class="nav navbar-expand-md navbar-light bg-light">
            <template v-for="(data, index) in nameAndRoute">
                <div class="nav-item">
                    <router-link class="nav-link" v-bind:to="{name: data.routeName}">
                        {{data.text}}
                    </router-link>
                </div>
            </template>
        </nav>
    </div>
</template>
<script>
  export default {
    props: {
      nameAndRoute: Array,
      routeName: String
    },
    data () {
      return {}
    },
    created() {
    }
  }

</script>
